<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索条件：
                        <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-input>
                    </div>

                </div>
                <div style="">
                    <el-radio-group v-model="searchVal.type" @change="searchDo">
                        <el-radio-button label="1">刷脸产品</el-radio-button>
                        <el-radio-button label="2">聚合产品</el-radio-button>
                    </el-radio-group>
                    <!--
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                    -->
                </div>

                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV"> <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true" /> </el-button>
                </div>
            </div>
            <div v-show="showFV" >
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>统计日期： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM-dd" style="width:250px;margin-right: 15px;" type="daterange" size="mini" unlink-panels start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" /></div>
                </div>
            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="jnl"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="agentName" label="服务商名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="签约日期" width="100"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.createTime.substring(0,10)}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalAmt" label="交易额" width="150" align="right"  sortable >
                    <template slot-scope="scope">
                        <div v-if="scope.row.totalAmt>0" style="font-weight: bolder;font-size: 14px; ">{{scope.row.totalAmt}}</div>
                        <div v-else style="">{{scope.row.totalAmt}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="recvAgentFee" label="交易笔数" width="100" align="right"  sortable >
                    <template slot-scope="scope">
                        <div v-if="scope.row.recvAgentFee>0" style="font-weight: bolder;font-size: 11px; ">{{scope.row.recvAgentFee}}</div>
                        <div v-else style="">{{scope.row.recvAgentFee}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="rewardAmt" label="手续费分润" width="120" align="right"  sortable >
                    <template slot-scope="scope">
                        <div v-if="scope.row.rewardAmt>0" style="font-weight: bolder;font-size: 14px; ">{{scope.row.rewardAmt}}</div>
                        <div v-else style="">{{scope.row.rewardAmt}}</div>
                    </template>
                </el-table-column>

                <el-table-column
                        align="center"
                        width="100"
                        label="结算费率">
                    <template slot-scope="scope">
                        <el-tag type="success" color="#FFFFFF">{{scope.row.feeAmt}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">明细</el-button>
                    </template>
                </el-table-column>


                <!--
                <el-table-column prop="rewardAmt" label="佣金分润" width="200" align="right" :formatter="funFmtTransAmt3" sortable />
                -->
            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData1" icon="el-icon-download" plain>导出</el-button>
            -->
            <div class="yx-flex-h-end">
                <el-pagination
                        :current-page.sync="page"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        :page-size="100"
                        layout="sizes, prev,pager,next, jumper,->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>


        <el-drawer
                :title=totalInfo.agentName
                :with-header="false"
                :visible.sync="drawer"
                :show-close=false
                size = "60%"
                direction="rtl">
            <div style="padding: 0 10px 30px 10px">
                <el-table :data="[totalInfo]" style="padding-left: 0px">
                    <el-table-column prop="totalAmt" label="交易额" />
                    <el-table-column prop="rewardAmt" label="手续费分润" />
                    <el-table-column
                            label="费率">
                        <template slot-scope="scope">
                            <el-tag type="success" color="#FFFFFF">{{scope.row.feeAmt}}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div style="margin: 10px;">
                <div style="width: 1px" />
                <!--
                <el-button type="success" @click="exportData2" icon="el-icon-download" plain>导出</el-button>
                -->
                <el-table :data="mchs" v-loading="loading2" size="mini" border stripe style="margin-top: 5px;">
                    <el-table-column type="index" label="序号" />
                    <el-table-column prop="agentName" label="商户名称" />
                    <el-table-column prop="totalAmt" label="交易额"  width="120" sortable />
                    <el-table-column prop="recvAgentFee" label="交易笔数"  width="110" sortable />
                    <el-table-column prop="rewardAmt" label="手续费分润"  width="110" sortable />
                </el-table>
                <!-- 分页栏 -->
                <div class="yx-flex-h-end">
                    <el-pagination small
                                   :page-size="size2"
                                   @current-change="currentChangeFA"
                                   @size-change="sizeChangeFA"
                                   layout="sizes, prev,pager,next, jumper,->, total, slot"
                                   :total="total2">
                    </el-pagination>
                </div>
            </div>
        </el-drawer>

    </div>

</template>

<script>
    export default {
        name: "RptAllAgentRwdTot", //服务商分润汇总
        data() {
            return {
                loading2: false,
                loading: false,
                showFV: false,
                total: 0,
                page: 1,
                size: 100,
                total2: 0,
                page2: 1,
                size2: 10,
                jnl: [],
                mchs: [],
                keywordList: [
                    {id:"agentName",name:"服务商名称"},
                ],
                searchVal: {
                    type:'1',
                    keywordMethod: '',
                    keyword: '',
                    totalTypes : [],
                    payWayCode : null,
                    payModeCode : null,
                    transDateScope : null
                },
                totalInfo:{

                },
                drawer: false
            }
        },
        mounted() {
            this.initJnl();
        },
        methods: {
            searchReset() {
                this.searchVal = {};
                this.searchVal.totalTypes = [];
            },
            searchDo() {
                this.page = 1;
                if(this.searchVal.type==='1') {
                    this.initJnl();
                }
                else {
                    this.jnl = [];
                    this.total = 0;
                }
            },
            viewDetail(data) {
                Object.assign(this.totalInfo, data);
                this.drawer = true;
                this.page2 = 1;
                this.size2 = 10;
                this.total2 = 0;
                this.initMch();
            },
            initMch() {
                this.loading2 = true;
                let url = '/agent/agentRewardTotalMch?page=' + this.page2 + '&size=' + this.size2 + '&id=' + this.totalInfo.id;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                /**
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                 */

                this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp) {
                        this.mchs = resp.data;
                        this.total2 = resp.total;
                    }
                });
            },
            initJnl() {
                this.loading = true;
                let url = '/agent/agentRewardTotal?page=' + this.page + '&size=' + this.size;
                /***/
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;


                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.jnl = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            exportData1() {
                let url = '/agent/agentRewardTotal/export?page=1';
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;


                window.open(url, '_parent');
            },
            exportData2() {
                let url = '/agent/agentRewardTotalMch/export?page=1' + '&id=' + this.totalInfo.id;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;

                window.open(url, '_parent');
            },
            funFmtTransAmt1(row, column) {
                return row.totalAmt.toFixed(2);
            },
            funFmtTransAmt2(row, column) {
                return row.feeAmt.toFixed(2);
            },
            funFmtTransAmt3(row, column) {
                return row.rewardAmt.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChangeFA(currentSize) {
                this.size2 = currentSize;
                this.initMch();
            },
            currentChangeFA(currentPage) {
                this.page2 = currentPage;
                this.initMch();
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initJnl();
            },
            getModelNameById(id) {
                if(this.$root.g_data_dev_model!==null) {
                    for(let i=0;i<this.$root.g_data_dev_model.length;i++) {
                        if(id===''+this.$root.g_data_dev_model[i].id) {
                            return this.$root.g_data_dev_model[i].model;
                        }
                    }
                }
                return '';
            }
        }
    }
</script>

<style>

</style>
